export class PeriodFormatter {
  constructor(private readonly _value: number) {}

  public padToTwoDigits(): string {
    return String(this._value).padStart(2, '0');
  }
}
